module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formpage"
  }, [_c('div', {
    staticClass: "right_col",
    attrs: {
      "role": "main"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/dashboard/form/new"
    }
  }, [_vm._v("新規フォーム作成")]), _c('div', {
    staticClass: "ln_solid"
  }), _c('table', {
    staticClass: "table table-bordered datatable"
  }, [_c('tbody', _vm._l((_vm.forms), function(form, index) {
    return _c('tr', {
      attrs: {
        "id": form.id,
        "index": index,
        "valid": form.is_valid
      }
    }, [_c('td', [_c('center', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (form.is_valid),
        expression: "form.is_valid"
      }],
      attrs: {
        "type": "checkbox",
        "name": "valid_chk",
        "true-value": 1,
        "false-value": 0,
        "data-size": "",
        "data-on-color": "success",
        "data-off-color": "default",
        "data-on-text": "",
        "data-off-text": ""
      },
      domProps: {
        "checked": Array.isArray(form.is_valid) ? _vm._i(form.is_valid, null) > -1 : _vm._q(form.is_valid, 1)
      },
      on: {
        "click": _vm.isValidChange,
        "change": function($event) {
          var $$a = form.is_valid,
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(form, "is_valid", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(form, "is_valid", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(form, "is_valid", $$c)
          }
        }
      }
    })])], 1), _c('td', {
      staticClass: "form_link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'messages',
          params: {
            id: form.id
          }
        }
      }
    }, [_vm._v(_vm._s(form.name))])], 1), _c('td', {
      staticClass: "icontablebutton"
    }, [_c('router-link', {
      staticClass: "tableicon btn btn-app glaybutton",
      attrs: {
        "to": {
          name: 'form',
          params: {
            id: form.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('span', [_vm._v("編集")])])])], 1), _c('td', {
      staticClass: "icontablebutton"
    }, [_c('button', {
      staticClass: "tableicon btn btn-app glaybutton",
      on: {
        "click": _vm.copyForm
      }
    }, [_vm._m(1, true)])]), _c('td', {
      staticClass: "icontablebutton"
    }, [_c('button', {
      staticClass: "tableicon btn btn-app glaybutton",
      attrs: {
        "href": "#",
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#codemodal",
        "data-whatever": index
      }
    }, [_vm._m(2, true)])]), _c('td', {
      staticClass: "icontablebutton"
    }, [_c('button', {
      staticClass: "tableicon btn btn-app deleteicon",
      on: {
        "click": _vm.deleteForm
      }
    }, [_vm._m(3, true)])])])
  }))]), _vm._m(4)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("フォーム管理")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-clone",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v("コピー")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-code",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v("埋め込みコード")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', [_vm._v("削除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "codemodal",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("埋め込みコード")]), _c('h5', [_vm._v("こちらのコードをコピーし、貼り付けてご使用ください。")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('textarea', {
    staticClass: "codetextarea",
    attrs: {
      "rows": "5",
      "readonly": "readonly"
    }
  })]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "customsmallbutton btn btn-success copy-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("クリップボードへコピー")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ac51bcc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Forms.vue
// module id = 611
// module chunks = 1